import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayPrimaryPhone'
})
export class DisplayPrimaryPhonePipe implements PipeTransform {

  transform(list: (ServerModels.ENESS_XREF_LEPartnersPhoneNumbers|ServerModels.ENESS_XREF_LEPartnersPhoneNumbersDTO)[]): string {
    if (!list || !list.length) {
      return '';
    }

    let primaryPhoneNumber = list.find((p) => p.IsPrimary);

    return !!primaryPhoneNumber ? primaryPhoneNumber.PhoneNumber : '';
  }
}
